export const SET_EXPERIMENT_CYBER = "SET_EXPERIMENT_CYBER";
export const CLEAN_EXPERIMENTS = "CLEAN_EXPERIMENTS";

export const SET_EXPERTIMENT_TRIPS_DISCOUNT = "SET_EXPERTIMENT_TRIPS_DISCOUNT";
export const SET_EXPERIMENT_BENEFITS = "SET_EXPERIMENT_BENEFITS";

export const SET_EXPERIMENT_MAINTENANCE_SCREEN = "SET_EXPERIMENT_MAINTENANCE_SCREEN";
